var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useRef, useEffect, useState } from "react";
import { useMergeRefs } from "../../../common/useFallbackRef";
var NavigationItem = forwardRef(function (_a, ref) {
    var className = _a.className, style = _a.style, children = _a.children, otherProps = __rest(_a, ["className", "style", "children"]);
    var _b = useState(false), alignRight = _b[0], setAlignRight = _b[1];
    var refItem = useRef(null);
    var combinedRefItem = useMergeRefs([ref, refItem]);
    useEffect(function () {
        if (refItem.current) {
            var collapseElement = refItem.current.querySelector(".fr-collapse.fr-menu");
            var parentElement = refItem.current.parentElement;
            if (collapseElement && parentElement) {
                var right = parentElement.getBoundingClientRect().right;
                var width = collapseElement.getBoundingClientRect().width;
                var left = refItem.current.getBoundingClientRect().left;
                if (left + width > right) {
                    setAlignRight(true);
                    return;
                }
            }
        }
        setAlignRight(false);
    }, [children]);
    var navigationItemClass = "fr-nav__item";
    if (alignRight) {
        navigationItemClass += " fr-nav__item--align-right";
    }
    if (className) {
        navigationItemClass += " ".concat(className);
    }
    return (React.createElement("li", __assign({}, otherProps, { ref: combinedRefItem, className: navigationItemClass, style: style }), children));
});
export default NavigationItem;
